import i18n from "i18next";
import { ColumnsType } from "antd/lib/table/interface";
import { GroupMembership } from "@type/core/dashboard/dashboard.types";
import DateFormat from "@utils/DateFormat";
import BasicButton from "@components/core/buttons/BasicButton";
import { Dispatch, SetStateAction } from "react";

export const columns = (
  setIsDeleteGroupMembershipOpen: Dispatch<SetStateAction<boolean>>,
  setIsDisableGroupMembershipOpen: Dispatch<SetStateAction<boolean>>,
  setSelectedGroupMembership: Dispatch<
    SetStateAction<GroupMembership | undefined>
  >,
): ColumnsType<GroupMembership> => [
  {
    title: i18n.t("offices.group.headers.membership"),
    dataIndex: "membership",
    sorter: true,
    showSorterTooltip: false,
  },
  {
    title: i18n.t("offices.group.headers.status"),
    dataIndex: "status",
    sorter: true,
    showSorterTooltip: false,
  },
  {
    title: i18n.t("offices.group.headers.sentDate"),
    dataIndex: "sentDate",
    sorter: true,
    showSorterTooltip: false,
    render: (sentDate: Date) => {
      return sentDate && DateFormat.fullDate(new Date(sentDate));
    },
  },
  {
    title: i18n.t("offices.group.headers.activatedDate"),
    dataIndex: "activatedDate",
    sorter: true,
    showSorterTooltip: false,
    render: (activatedDate: Date) => {
      return activatedDate && DateFormat.fullDate(new Date(activatedDate));
    },
  },
  {
    title: i18n.t("offices.group.headers.refusalDate"),
    dataIndex: "refusalDate",
    sorter: true,
    showSorterTooltip: false,
    render: (refusalDate: Date) => {
      return refusalDate && DateFormat.fullDate(new Date(refusalDate));
    },
  },
  {
    title: i18n.t("offices.group.headers.disabledDate"),
    dataIndex: "disabledDate",
    sorter: true,
    showSorterTooltip: false,
    render: (disabledDate: Date) => {
      return disabledDate && DateFormat.fullDate(new Date(disabledDate));
    },
  },
  {
    dataIndex: "status",
    width: 138,
    render: (status: string, record: GroupMembership) => {
      return (
        <>
          {status === "Saisi" && (
            <BasicButton
              variant="tertiary"
              text={i18n.t("buttons.delete")}
              onClick={() => {
                setSelectedGroupMembership(record);
                setIsDeleteGroupMembershipOpen(true);
              }}
              className="w-100"
            />
          )}
          {status === "Activé" && (
            <BasicButton
              variant="tertiary"
              text={i18n.t("buttons.disable")}
              onClick={() => {
                setSelectedGroupMembership(record);
                setIsDisableGroupMembershipOpen(true);
              }}
              className="w-100"
            />
          )}
        </>
      );
    },
  },
];
